let $ = require('jquery');
let Promise = require('bluebird');
let {
    debounce, randstr, url
} = require('../utils');
let modal = require('../helpers/modal');
let chaos = require('../helpers/chaos');
let request = require('superagent');

let client = require('sci/helpers/client');

let template = require('templates/quick-customer.hbs');
let viewTemplate = require('templates/customers/modal-quick-view.hbs');

let sendForm = (it) => function ($modal, close) {
    if ($modal.find('.primary-button').is('.disabled')) {
        return;
    }

    $modal.find('.primary-button').addClass('disabled');

    let $form = $modal.find('.quick-customer-form');
    let $phoneExistsAlert = $form.find('.quick-customer-form-phone-exists');
    let $phoneExistsAlertMessage = $phoneExistsAlert.find('.alert');

    let data = $form.serializeArray().reduce((accumulator, item) => {
        return {...accumulator, [item.name]: item.value}
    }, {});

    data.with_form = it.hasClass('with-form') || data.with_form === "on"

    data.phone = data.phone.replace(/[^\*0-9]/g, '');

    request
        .post(url('customers/quick-add'), data)
        .end(function (err, response) {
            $modal.find('.primary-button').removeClass('disabled');

            chaos($form, response)
                .then((data) => {
                    close();
                    switch (it.data('mode')) {
                        case 'create':
                            it.trigger('registered', data);
                            break;
                        default:
                            if (data.formsCount.opened) {
                                let form = data.forms.shift()
                                location.href = `/forms/${form.id}`
                                return
                            }

                            location.href = `/customers/${data.id}`
                    }
                })
                .catch((ex) => {
                    $phoneExistsAlert.hide();
                    let data = JSON.parse(response.text);
                    let meta = data.meta;
                    if (meta) {

                        let customersPhones = meta.customers_phones;
                        let customersEmails = meta.customers_emails;

                        $phoneExistsAlertMessage.empty();

                        if (customersPhones && customersPhones.length) {
                            $phoneExistsAlert.show();
                            let customer = customersPhones[0];
                            let append = "";

                            if (customer.formsCount.opened) {
                                append = ` Esse cliente também possui uma FAC em aberto. Clique nesse alerta para ir até seus negócios.`
                            } else {
                                append = ` Clique nesse alerta para usar esse cadastro.`
                            }

                            $phoneExistsAlertMessage.append(
                                `<div>Esse telefone já está sendo usado pelo cliente <b>${customer.name}</b>.${append}</div>`
                            );

                            $phoneExistsAlert.unbind().click(() => {
                                switch (it.data('mode')) {
                                    case 'create':
                                        it.trigger('registered', customer);
                                        $modal.trigger('modal.close');
                                        break;
                                    default:
                                        if (customer.formsCount.opened) {
                                            let form = customer.forms.shift()
                                            location.href = `/forms/${form.id}`
                                        } else {
                                            location.href = `/customers/${customer.id}`
                                        }
                                }
                            });
                        }

                        if (customersEmails && customersEmails.length) {
                            $phoneExistsAlert.show();
                            let customer = customersEmails[0];

                            let append = "";

                            if (customer.formsCount.opened) {
                                append = ` Esse cliente também possui uma FAC em aberto. Clique nesse alerta para ir até seus negócios.`
                            } else {
                                append = ` Clique nesse alerta para usar esse cadastro.`
                            }

                            $phoneExistsAlertMessage.append(
                                `<div>Esse e-mail já está sendo usado pelo cliente <b>${customer.name}</b>.${append}</div>`
                            );

                            $phoneExistsAlert.unbind().click(() => {
                                switch (it.data('mode')) {
                                    case 'create':
                                        it.trigger('registered', customer);
                                        $modal.trigger('modal.close');
                                        break;
                                    default:
                                        if (customer.formsCount.opened) {
                                            let form = customer.forms.shift()
                                            location.href = `/forms/${form.id}`
                                        } else {
                                            location.href = `/customers/${customer.id}`
                                        }
                                }
                            });
                        }
                    }
                });
        });
};

let quickCustomer = (self = $(document)) => new Promise((resolve, reject) => {
    self.find('.quick-customer').each(function () {
        let it = $(this);
        let withForm = it.hasClass('with-form');

        let title = null;
        switch (it.data('mode')) {
            case 'create':
                if (withForm) {
                    title = `<i class="icon-rocket"></i> Criar negócio`;
                    break;
                }
                title = `<i class="glyphicon glyphicon-user"></i> Cadastrar novo cliente`;
                break;
            default:
                title = `<i class="glyphicon glyphicon-user"></i> Cadastrar novo cliente`;
        }

        it.click(function () {
            let $modal = modal({
                title,
                body: template({
                    with_form: withForm ? 'checked' : ''
                }),
                primaryButton: `Continuar <i class="fa fa-arrow-circle-right"></i>`,
                width: 300,
                onPrimaryButton: sendForm(it),
                onShown: function ($modal) {
                    $modal
                        .find('.form-control')
                        .first()
                        .focus();
                }
            });

            $modal.find('[name=phone]').inputmask({alias: 'br_phones'});
            $modal.find('.uniform').uniform();

            let $form = $modal.find('.quick-customer-form');

            $form.submit(function () {
                sendForm(it)($modal, function () {
                    $modal.trigger('modal.close');
                });
                return false;
            });
        });
    });

    self.find('.quick-view-customer').each(function () {
        let it = $(this);

        if (it.hasClass('bound-quick-view-customer')) {
            return
        }

        it.addClass('bound-quick-view-customer')

        it.click(function () {
            let id = it.attr('data-id');
            let root = it.attr('data-root') || '/customers/';

            let $modal = modal({
                title: `Informações do Cliente`,
                body: `<div class="text-center">Carregando... <img src="/assets/images/preloader.gif" /></div>`,
                primaryButton: `Ver cadastro completo`,
                secondaryButton: `Fechar`,
                width: 600,
                onPrimaryButton: function ($modal) {
                    location.href = root + id
                }
            });

            client
                .silent()
                .get('Carregando...', `customers/${id}`)
                .then(function (response) {
                    $modal.trigger('modal.body-changed', viewTemplate(response.data));
                });
        });
    });

    resolve();
});




module.exports = quickCustomer;



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/ui/quick-customer.js